import { useEffect } from 'react';
import Image from 'next/image';
import gsap from 'gsap';

const AnimCard7 = () => {
  useEffect(() => {
    gsap.context(() => {
      gsap
        .timeline({
          repeat: -1
        })
        .fromTo(
          '.anim-card-7-coin-1-js',
          {
            autoAlpha: 0
          },
          {
            autoAlpha: 1,
            stagger: {
              each: 0.1,
              from: 'end'
            }
          }
        )
        .fromTo(
          '.anim-card-7-coin-2-js',
          {
            autoAlpha: 0
          },
          {
            autoAlpha: 1,
            stagger: {
              each: 0.1,
              from: 'end'
            }
          }
        );
    });
  }, []);

  return (
    <>
      <div className="absolute inset-0">
        <Image
          src="/images/animcards/7/chico.svg"
          width={228}
          height={193}
          alt=""
          className="w-full h-full object-cover"
        />
      </div>
      <div className="absolute top-[3%] left-[45%]">
        <div className="relative flex flex-col justify-center">
          <svg
            className="w-11 h-auto | anim-card-7-coin-1-js"
            viewBox="0 0 11 3"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path d="M0.833252 0.288086H10.5337V2.45103H0.833252V0.288086Z" fill="#F9A578" />
          </svg>
          <svg
            className="w-11 h-auto | anim-card-7-coin-1-js"
            viewBox="0 0 11 3"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path d="M0.833252 0.450928H10.5337V2.61387H0.833252V0.450928Z" fill="#FD813E" />
          </svg>
          <svg
            className="w-11 h-auto | anim-card-7-coin-1-js"
            viewBox="0 0 11 3"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path d="M0.833252 0.288086H10.5337V2.45103H0.833252V0.288086Z" fill="#F9A578" />
          </svg>
          <svg
            className="w-11 h-auto | anim-card-7-coin-1-js"
            viewBox="0 0 11 3"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path d="M0.833252 0.450928H10.5337V2.61387H0.833252V0.450928Z" fill="#FD813E" />
          </svg>
          <svg
            className="w-11 h-auto | anim-card-7-coin-1-js"
            viewBox="0 0 11 3"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path d="M0.833252 0.288086H10.5337V2.45103H0.833252V0.288086Z" fill="#F9A578" />
          </svg>
          <svg
            className="w-11 h-auto | anim-card-7-coin-1-js"
            viewBox="0 0 11 3"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path d="M0.833252 0.450928H10.5337V2.61387H0.833252V0.450928Z" fill="#FD813E" />
          </svg>
          <svg
            className="w-11 h-auto | anim-card-7-coin-1-js"
            viewBox="0 0 11 3"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path d="M0.833252 0.288086H10.5337V2.45103H0.833252V0.288086Z" fill="#F9A578" />
          </svg>
          <svg
            className="w-11 h-auto | anim-card-7-coin-1-js"
            viewBox="0 0 11 3"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path d="M0.833252 0.450928H10.5337V2.61387H0.833252V0.450928Z" fill="#FD813E" />
          </svg>
          <svg
            className="w-11 h-auto | anim-card-7-coin-1-js"
            viewBox="0 0 11 3"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path d="M0.833252 0.288086H10.5337V2.45103H0.833252V0.288086Z" fill="#F9A578" />
          </svg>
          <svg
            className="w-11 h-auto | anim-card-7-coin-1-js"
            viewBox="0 0 11 3"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path d="M0.833252 0.450928H10.5337V2.61387H0.833252V0.450928Z" fill="#FD813E" />
          </svg>
        </div>
      </div>
      <div className="absolute top-[7.5%] left-[52%]">
        <div className="relative flex flex-col justify-center">
          <svg
            className="w-11 h-auto | anim-card-7-coin-2-js"
            viewBox="0 0 11 3"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path d="M0.833252 0.288086H10.5337V2.45103H0.833252V0.288086Z" fill="#F9A578" />
          </svg>
          <svg
            className="w-11 h-auto | anim-card-7-coin-2-js"
            viewBox="0 0 11 3"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path d="M0.833252 0.450928H10.5337V2.61387H0.833252V0.450928Z" fill="#FD813E" />
          </svg>
          <svg
            className="w-11 h-auto | anim-card-7-coin-2-js"
            viewBox="0 0 11 3"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path d="M0.833252 0.288086H10.5337V2.45103H0.833252V0.288086Z" fill="#F9A578" />
          </svg>
          <svg
            className="w-11 h-auto | anim-card-7-coin-2-js"
            viewBox="0 0 11 3"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path d="M0.833252 0.450928H10.5337V2.61387H0.833252V0.450928Z" fill="#FD813E" />
          </svg>
          <svg
            className="w-11 h-auto | anim-card-7-coin-2-js"
            viewBox="0 0 11 3"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path d="M0.833252 0.288086H10.5337V2.45103H0.833252V0.288086Z" fill="#F9A578" />
          </svg>
          <svg
            className="w-11 h-auto | anim-card-7-coin-2-js"
            viewBox="0 0 11 3"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path d="M0.833252 0.450928H10.5337V2.61387H0.833252V0.450928Z" fill="#FD813E" />
          </svg>
          <svg
            className="w-11 h-auto | anim-card-7-coin-2-js"
            viewBox="0 0 11 3"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path d="M0.833252 0.288086H10.5337V2.45103H0.833252V0.288086Z" fill="#F9A578" />
          </svg>
        </div>
      </div>
    </>
  );
};
export default AnimCard7;
